export { useAssignCommercialExecutiveGoal } from './useAssignCommercialExecutiveGoal'
